const logo = require('@/assets/login/logo.png');
import { validEmail } from '@/utils/validate';
export default {
  data: function () {
    const validateEmail = (rule, value, callback) => {
      if (!validEmail(value)) {
        callback(new Error('有効なメールアドレスを入力してください。'));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error('パスワードは4つ文字以上を入力してください。'));
      } else {
        callback();
      }
    };
    return {
      loginRules: {
        email: [{ required: true, trigger: 'blur', validator: validateEmail }],
        password: [{ required: true, trigger: 'blur', validator: validatePass }],
      },
      loading: false,
      pwdType: 'password',
      redirect: undefined,
      otherQuery: {},
      logo: logo,
    };
  },
  methods: {

  }
}